export { default } from './bottom-tab-bar';
